<template>

  <v-select 
    :taggable="taggable"
    :value="currentValue"
    @input="change"
    :options="allOptions"
    label="label"
    :placeholder="placeholder"
    :onSearch="searchEmail"
    :selectOnTab="true">
    </v-select>

</template>

<script>
import extractEmail from '@/utils/ExtractEmail'

export default {
  name: 'SelectizeEmail',
  props: {
    'value': {
      type: Object,
      default: () => { return null }
    },
    'options': {
      type: Array,
      default: () => { return [] }
    },
    'taggable': {
      type: Boolean,
      default: true
    },
    'placeholder': {
      type: String,
      default: function () {
        return this.$t('Enter email')
      }
    }
  },
  data () {
    return {
      searchOptions: []
    }
  },
  computed: {
    currentValue () {
      return this.setLabel(this.value)
    },
    allOptions () {
      return [...this.options, ...this.searchOptions].map((val) => {
        return this.setLabel(val)
      })
    }
  },
  created () {
  },
  methods: {
    setLabel (val) {
      if (val) {
        return Object.assign(val, {
          label: (val.name === val.email || !val.name) ? val.email : `${val.name} <${val.email}>`
        })
      }
      return val
    },
    change (value) {
      // quando input é definido, v-select redispara input
      // isso faz o controle para nao entrar em loop infinito
      if (!value && value !== this.value) {
        this.$emit('input', value)
      } else if (JSON.stringify(value) !== JSON.stringify(this.value)) {
        const extracted = value.email ? value : extractEmail(value.label || value)
        this.$emit('input', extracted)
      }
    },
    searchEmail (search, loading) {
      loading(true)
      return this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/autocomplete/emails', {params: {q: search}})
      .then((response) => {
        this.searchOptions = response.data
        loading(false)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectizeEmail.vue